import { observable, action } from 'mobx'
import _ from 'lodash'

let NavStore = observable({
    Status: false
})

_.assign(NavStore, {
    // openNav: action(function(){
    //     // this.NavStatus = !this.NavStatus
    //     NavStore.NavStatus = true
    // }),
    Toggle: action(function(){
        NavStore.Status = !NavStore.Status
    }),
    Close: action(function(){
        NavStore.Status = false
    })
})

export default NavStore


// WEBPACK FOOTER //
// ./src/stores/NavStore.js